import {
  ADD_PROMO_FAILURE,
  CLEAR_BASKET,
  CLEAR_BASKET_ERRORS,
  CLEAR_PROMO_CODE_FAILURE,
  CREATE_BASKET_DETAILS_FAILURE,
  CREATE_BASKET_DETAILS_REQUEST,
  CREATE_BASKET_DETAILS_SUCCESS,
  CREATE_ORDER_FAILURE,
  CREATE_ORDER_REQUEST,
  CREATE_ORDER_SUCCESS,
  FETCH_BASKET_DETAILS_FAILURE,
  FETCH_BASKET_DETAILS_REQUEST,
  FETCH_BASKET_DETAILS_SUCCESS,
  FETCH_ORDER_FAILURE,
  FETCH_ORDER_REQUEST,
  FETCH_ORDER_SUCCESS,
  ORDER_STATUS_CARD_DECLINED,
  ORDER_STATUS_FAILURE,
  ORDER_STATUS_REQUEST,
  ORDER_STATUS_RESET,
  ORDER_STATUS_SUCCESS,
  ORDER_STATUS_UNKNOWN,
  UPDATE_BASKET_DETAILS_FAILURE,
  UPDATE_BASKET_DETAILS_REQUEST,
  UPDATE_BASKET_DETAILS_SUCCESS,
  UPDATE_BASKET_PRICING_FAILURE,
  UPDATE_BASKET_PRICING_REQUEST,
  UPDATE_BASKET_PRICING_SUCCESS,
  UPDATE_ORDER,
  UPDATE_PAYMENT_OPTION_FAILURE,
  UPDATE_PAYMENT_OPTION_REQUEST,
  UPDATE_PAYMENT_OPTION_SUCCESS,
} from '@store/basket/actions';
import { isOrderPaymentConfirmed } from 'shared-types';

export const initialState = {
  errors: null,
  isBasketDetailsFetching: false,
  isOrderCreateFetching: false,
  isOrderFetching: false,
  orderCreateError: false,
  orderFetchError: false,
  isBasketPricingFetching: false,
  basketDetails: {
    id: '',
    items: [],
    subtotal: {},
    tax_total: {},
    total: {
      currencyCode: 'gbp',
      amount: 0,
    },
    created_at: '',
    updated_at: '',
  },
  basketPricing: {},
  order: null as { clientSecret?: string } | null,
  isOrderStatusUpdating: false,
  isPaymentOptionUpdating: false,
  paymentOptionError: false,
  orderStatusError: false,
  orderStatusUnknown: false,
  promoCodeFailure: false,
};

export default (state = initialState, action) => {
  const { payload, errors } = action;

  switch (action.type) {
    case FETCH_BASKET_DETAILS_REQUEST:
    case CREATE_BASKET_DETAILS_REQUEST:
    case UPDATE_BASKET_DETAILS_REQUEST: {
      return {
        ...state,
        isBasketDetailsFetching: true,
      };
    }

    case UPDATE_BASKET_PRICING_REQUEST: {
      return {
        ...state,
        isBasketPricingFetching: true,
      };
    }

    case FETCH_BASKET_DETAILS_SUCCESS: {
      return {
        ...state,
        basketDetails: {
          ...payload,
        },
        isBasketDetailsFetching: false,
      };
    }
    case CREATE_BASKET_DETAILS_SUCCESS:
    case UPDATE_BASKET_DETAILS_SUCCESS: {
      return {
        ...state,
        errors: null,
        basketDetails: {
          ...payload,
        },
        promoCodeFailure: false,
        isBasketDetailsFetching: false,
      };
    }
    case CREATE_BASKET_DETAILS_FAILURE:
    case UPDATE_BASKET_DETAILS_FAILURE: {
      return {
        ...state,
        errors,
        isBasketDetailsFetching: false,
      };
    }
    case FETCH_BASKET_DETAILS_FAILURE: {
      return {
        ...state,
        isBasketDetailsFetching: false,
      };
    }
    case ADD_PROMO_FAILURE: {
      return {
        ...state,
        promoCodeFailure: !!errors,
        isBasketDetailsFetching: false,
      };
    }
    case CLEAR_BASKET_ERRORS: {
      return {
        ...state,
        errors: null,
      };
    }
    case CLEAR_PROMO_CODE_FAILURE: {
      return {
        ...state,
        promoCodeFailure: false,
      };
    }
    case CREATE_ORDER_REQUEST: {
      return {
        ...state,
        isOrderCreateFetching: true,
        order: initialState.order,
        orderStatusError: initialState.orderStatusError,
        orderStatusUnknown: initialState.orderStatusUnknown,
      };
    }
    case CREATE_ORDER_SUCCESS: {
      return {
        ...state,
        isOrderCreateFetching: false,
        orderCreateError: false,
        order: payload,
      };
    }
    case CREATE_ORDER_FAILURE: {
      return {
        ...state,
        isOrderCreateFetching: false,
        orderCreateError: true,
      };
    }
    case FETCH_ORDER_REQUEST: {
      return {
        ...state,
        isOrderFetching: true,
        orderFetchError: false,
      };
    }
    case FETCH_ORDER_SUCCESS: {
      return {
        ...state,
        isOrderFetching: false,
        orderFetchError: false,
        order: payload,
      };
    }
    case FETCH_ORDER_FAILURE: {
      return {
        ...state,
        isOrderFetching: false,
        orderFetchError: true,
      };
    }
    case UPDATE_ORDER: {
      return {
        ...state,
        order: {
          ...state.order,
          ...payload,
          clientSecret: state.order?.clientSecret,
        },
      };
    }
    case UPDATE_PAYMENT_OPTION_REQUEST: {
      return {
        ...state,
        isPaymentOptionUpdating: true,
        paymentOptionError: false,
      };
    }
    case UPDATE_PAYMENT_OPTION_SUCCESS: {
      return {
        ...state,
        isPaymentOptionUpdating: false,
        paymentOptionError: false,
        order: {
          ...(state.order || {}),
          ...payload,
        },
      };
    }
    case UPDATE_PAYMENT_OPTION_FAILURE: {
      return {
        ...state,
        isPaymentOptionUpdating: false,
        paymentOptionError: true,
      };
    }
    case ORDER_STATUS_REQUEST: {
      return {
        ...state,
        isOrderStatusUpdating: true,
      };
    }
    case ORDER_STATUS_SUCCESS: {
      const orderStatus = payload?.orderStatus;
      const isConfirmed = isOrderPaymentConfirmed(orderStatus);
      return {
        ...state,
        isOrderStatusUpdating: false,
        orderStatusError: !isConfirmed,
        order: {
          ...state.order,
          orderStatus,
        },
      };
    }
    case ORDER_STATUS_FAILURE: {
      return {
        ...state,
        isOrderStatusUpdating: false,
        orderStatusError: true,
      };
    }
    case ORDER_STATUS_UNKNOWN: {
      return {
        ...state,
        isOrderStatusUpdating: false,
        orderStatusUnknown: true,
      };
    }
    case ORDER_STATUS_CARD_DECLINED: {
      return {
        ...state,
        isOrderStatusUpdating: false,
        orderStatusError: true,
        order: {
          ...state.order,
          clientSecret: action.payload,
        },
      };
    }
    case ORDER_STATUS_RESET: {
      return {
        ...state,
        isOrderStatusUpdating: false,
        orderStatusError: false,
        orderStatusUnknown: false,
      };
    }
    case CLEAR_BASKET: {
      return {
        ...state,
        basketDetails: { ...initialState.basketDetails },
      };
    }
    case UPDATE_BASKET_PRICING_FAILURE: {
      return {
        ...state,
        isBasketPricingFetching: false,
      };
    }
    case UPDATE_BASKET_PRICING_SUCCESS: {
      return {
        ...state,
        basketPricing: payload,
      };
    }
    default:
      return state;
  }
};
